export default __webpack_public_path__ + "static/media/immunization.a572fb14.png";